module.exports = __webpack_public_path__ + "img/close.d40f759a.png";